import { useQuery } from "@apollo/client";
import useActivePayee from "../useActivePayee";
import {
  GET_PAYEE_CURBPASS_SETTINGS,
  GetPayeeCurbPassSettingsData,
  GetPayeeCurbPassSettingsVars,
  PayeeCurbPassSettings,
} from "common/graphql";

/**
 * Returns the curb pass settings for the given payee account ID. If no payee account ID is provided, the function will use the active payee account ID.
 */
export function usePayeeCurbpassSettings(payeeAccountId?: string): UsePayeeCurbpassSettingsResult {
  const { activePayee } = useActivePayee();
  const settingsPayeeAccountId = payeeAccountId || activePayee?.payeeAccountId;

  const { data, loading, error } = useQuery<GetPayeeCurbPassSettingsData, GetPayeeCurbPassSettingsVars>(
    GET_PAYEE_CURBPASS_SETTINGS,
    {
      variables: {
        payeeAccountId: settingsPayeeAccountId || "",
      },
      skip: !settingsPayeeAccountId,
    },
  );

  return {
    loading,
    error,
    curbPassSettings: data?.payeeCurbPassSettings[0] || undefined,
  };
}

export interface UsePayeeCurbpassSettingsResult {
  loading: boolean;
  error?: Error;
  curbPassSettings?: PayeeCurbPassSettings;
}

export default usePayeeCurbpassSettings;
